import { useRef, useEffect } from "react";

export default function useThis(value) {
  const ref = useRef(value);

  ref.current = value;

  return ref;
}
